import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PhoneOff } from "lucide-react";

// Owner/admin-only report of saved mobile numbers that fail the 10-digit rule. Read-only.
export function PhoneIssuesButton() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { data } = useQuery({ queryKey: ["phone-issues"], enabled: open, queryFn: async () => (await api.get("/customers/phone-issues")).data });
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="phone-issues-btn" className="gap-1.5"><PhoneOff className="h-4 w-4" /> Phone issues</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white max-w-md" data-testid="phone-issues-dialog">
          <DialogHeader><DialogTitle className="font-display">Customer phone number issues</DialogTitle></DialogHeader>
          <DialogDescription className="text-xs text-slate-500">Nothing is changed automatically. Open a customer and correct the number; it must be 10 digits to save.</DialogDescription>
          {!data ? <p className="text-xs text-slate-400">Loading…</p> : (
            <>
              <p className="text-xs text-slate-600" data-testid="phone-issues-summary">{data.invalid_count} invalid · {data.missing_count} without a number</p>
              <div className="max-h-[50vh] divide-y divide-slate-100 overflow-y-auto">
                {data.invalid.map((c) => (
                  <button key={c.id} onClick={() => navigate(`/customers/${c.id}`)} data-testid={`phone-issue-${c.id}`}
                    className="flex w-full items-center justify-between py-2 text-left text-sm hover:bg-slate-50">
                    <span className="font-medium text-slate-800">{c.name || "—"}</span><span className="font-mono text-xs text-rose-600">{c.mobile}</span>
                  </button>
                ))}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
